import { type UseSuspenseQueryOptions } from '@tanstack/react-query';
import { opinetApi } from '@/shared/api';
import { MINUTE } from '@/shared/consts';
import type { OpinetStationDetailResponse } from '@/shared/types';
import { stationKeys } from './station.keys';

export const stationInfoQueryOption = (
	stationId?: string,
): UseSuspenseQueryOptions<OpinetStationDetailResponse | null> => ({
	queryFn: () => {
		if (!stationId) return null;
		return opinetApi.getStationInfo(stationId);
	},
	queryKey: stationKeys.detail(stationId ?? ''),
	staleTime: 5 * MINUTE,
	gcTime: 10 * MINUTE,
});
